// All carry bubbles: true, composed: true so they cross shadow-DOM boundaries.
export type SchmancyRangeEvent = CustomEvent<{ first: number; last: number }>
export type SchmancyVisibilityEvent = CustomEvent<{ first: number; last: number }>
export type SchmancyEndReachedEvent = CustomEvent<Record<string, never>>

export function rangeEvent(first: number, last: number): SchmancyRangeEvent {
	return new CustomEvent('rangechange', {
		detail: { first, last },
		bubbles: true,
		composed: true,
	}) as SchmancyRangeEvent
}

export function visibilityEvent(first: number, last: number): SchmancyVisibilityEvent {
	// This composed event reaches document; its native lifecycle name must stay separate.
	return new CustomEvent('schmancy-visibilitychange', {
		detail: { first, last },
		bubbles: true,
		composed: true,
	}) as SchmancyVisibilityEvent
}

export function endReachedEvent(): SchmancyEndReachedEvent {
	return new CustomEvent('endreached', {
		detail: {},
		bubbles: true,
		composed: true,
	}) as SchmancyEndReachedEvent
}
